import React from 'react'
import UIkit from 'uikit'
import { connect } from 'react-redux'
import introJs from 'intro.js';

// components
import Modal from '../../../UIkit/Modal'

class ModalLessonTour extends React.Component {
  constructor(props) {
    super(props)

    this.handleStartLessonTour = this.handleStartLessonTour.bind(this)
  }

  handleStartLessonTour() {
    UIkit.modal('#modal-lesson-tour').hide()

    const steps = [
      {
        element: document.querySelectorAll('#skill-steps')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Lesson Instructions</h4>
            <p>This area will walk you through each step in the lesson and includes all of the hands-on training instructions.</p>
            <p>Once you're done with the step click the Next button at the bottom to continue through the class.</p>
          </div>
        `,
        tooltipPosition: 'right',
        position: 'right',
      }, {
        element: document.querySelectorAll('#browser')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Browser Sandbox</h4>
            <p>This panel is the browser sandbox. It acts very similar to a normal browser. You can view the source code of the browser by clicking on "View Source". Many vulnerabilities can be found by viewing the web application front-end code. To get back to the browser click "View Browser".</p>
          </div>
        `,
        position: 'left',
      }, {
        element: document.querySelectorAll('#proxy-intercept')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Intercept Requests</h4>
            <p>To turn on the proxy ensure the "Intercept Requests" button is checked. This will hold HTTP requests sent until the Submit Request button is hit. It is a good idea to explore web applications with intercept off so it doesn't slow you down. Once you start testing it is a good idea to have it turned on to analyze requests.</p>
          </div>
        `,
        position: 'bottom',
      }, {
        element: document.querySelectorAll('#proxy-status')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Proxy Status</h4>
            <p>The proxy status lets you know whether or not you are listening to requests. Click on it to learn more about each status type.</p>
          </div>
        `,
        position: 'bottom',
      }, {
        element: document.querySelectorAll('#proxy-request-button')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Proxy</h4>
            <p>This button expands the web application proxy where you will man-in-the-middle HTTP requests and responses from/to the application browser. The proxy will also automatically pop out when you are intercepting requests.</p>
          </div>
        `,
        highlightClass: 'tour-dark',
        position: 'left',
      }, {
        element: document.querySelectorAll('#proxy-history-button')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Proxy History</h4>
            <p>The History tab in the proxy shows the HTTP requests as well as the responses from those requests. If you click on the plus next to the request you will be able to see the HTTP request and the corresponding responses. This is very useful in seeing responses based on past requests.</p>
          </div>
        `,
        highlightClass: 'tour-dark',
        position: 'right',
      }, {
        element: document.querySelectorAll('#proxy-code-div')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Code Editor</h4>
            <p>The Code Editor allows you to patch the vulnerable function in your sandbox. You can change the language of your code with a dropdown menu, and see any output from your code below the text editor.</p>
          </div>
        `,
        highlightClass: 'tour-dark',
        position: 'right',
      }, {
        element: document.querySelectorAll('#proxy-code-output-div')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Code Output & Errors</h4>
            <p>This tab displays any printed output from your code, which can help debug. It works just like your console/terminal window in your normal development environment.</p>
          </div>
        `,
        highlightClass: 'tour-dark',
        position: 'right',
      }, {
        element: document.querySelectorAll('#proxy-patches-div')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Patch History</h4>
            <p>This tab shows you a history of all of the patches you have submitted, shows if that patch fixed the vulnerability, and the reason why a patch has failed if it did not work.</p>
          </div>
        `,
        highlightClass: 'tour-dark',
        position: 'right',
      }, {
        element: document.querySelectorAll('#proxy-reset')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Reset Sandbox</h4>
            <p>If you break the web application in your browser sandbox and want a fresh start, clicking Reset Sandbox will give you a brand new web application.</p>
          </div>
        `,
        position: 'bottom',
      },
    ]

    if (this.props.showCode === false) {
      steps.splice(6, 1)
    }

    const tour = introJs()
      .setOptions({
        skipLabel: 'Skip Tour',
        showStepNumbers: false,
        hideNext: true,
        hidePrev: true,
        exitOnOverlayClick: false,
        disableInteraction: true,
        steps,
      })

    tour.start()
  }

  render() {
    return (
      <Modal
        id="modal-lesson-tour"
        data-test-id="modal-lesson-tour"
        titleTestId="title-modal-lesson-tour"
        title="HackEDU Lesson Tour"
        body={
          <div className="uk-text-center">
            <p>
              This tour walks you through the different aspects of our lesson
              interface for Web Application Security.
            </p>
            <div className="uk-margin">
              <button
                className="uk-button uk-button-primary uk-margin-right uk-margin-remove-bottom"
                data-test-id="btn-tour-start-the-tour"
                style={{
                  padding: '0 30px',
                }}
                onClick={this.handleStartLessonTour}
              >
                Take the tour
              </button>
              <button
                className="uk-button uk-button-muted uk-margin-remove-bottom"
                style={{
                  padding: '0 30px',
                }}
                onClick={() => { UIkit.modal('#modal-lesson-tour').hide() }}
                data-test-id="btn-tour-start-the-lesson"
              >
                Start the lesson
              </button>
            </div>
          </div>
        }
        containerModifier
      />
    )
  }
}

const mapStateToProps = state => ({
  replFlag: state.repl.flag,
})
export default connect(mapStateToProps)(ModalLessonTour)
